import { Box, Typography, Button } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as SuccessIcon } from 'src/assets/svg/success-green-circle.svg';
import { appConfig } from 'src/app';
import { getTheme } from 'src/utils/getTheme';

import { styles } from './styles';

export const BookingUpdatedPage: FC = () => {
    const { t } = useTranslation();
    const { isHosTheme } = getTheme();
    const accountPage = isHosTheme ? appConfig.myAccountUrl.hos : appConfig.myAccountUrl.vs;

    return (
        <Box css={styles.container}>
            <Box css={styles.imageContainer} />

            <Box css={styles.wrapper}>
                <SuccessIcon />

                <Typography variant="h1" css={styles.title}>
                    {t('booking_updated_title')}
                </Typography>

                <Typography
                    variant="body3"
                    dangerouslySetInnerHTML={{ __html: t('booking_updated_content') }}
                />

                <Button variant="contained" css={styles.cta} href={accountPage}>
                    {t('success_btn')}
                </Button>
            </Box>
        </Box>
    );
};
